import styled, { css } from 'styled-components';

export const ChartContainer = styled.div`
  ${({ theme }) => css`
    height: 400px;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      height: 300px;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      height: 250px;
    }
  `}
`;

export const EmptyStateContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
    height: 100%;
    color: ${theme.v3.colors.neutral[40]};
  `}
`;

export const EmptyImage = styled.img`
  width: 64px;
  height: 64px;
  margin-bottom: 24px;
`;

export const EmptyTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;
  `}
`;

export const EmptyDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[60]};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;
  `}
`;
